import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { SubscribeBlock } from "./SubscribeBlock";
import { api, scrollToHash } from "@/lib/api";

export const Footer = () => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="border-t border-midnight/10 bg-[#FAFAFA]" data-testid="site-footer">
      <SubscribeBlock />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-3 mb-5">
            <LogoMark size={30} />
            <div className="leading-none">
              <div className="font-heading font-semibold tracking-[0.14em] text-midnight text-sm">ROYAL DEALS <span className="text-gold">FZ-LLC</span></div>
              <div className="font-heading text-[9px] font-medium tracking-[0.3em] text-midnight/45 mt-1">ADVANCED COMPUTE</div>
            </div>
          </div>
          <p className="text-sm text-midnight/55 leading-relaxed">
            {settings?.footer_note || "UAE-based advanced compute and technology supply company serving the GCC and international markets."}
          </p>
          {settings?.contact_email && (
            <a href={`mailto:${settings.contact_email}`} data-testid="footer-email" className="block mt-4 text-sm font-medium text-midnight hover:text-gold transition-colors">
              {settings.contact_email}
            </a>
          )}
          {settings?.phone && (
            <p className="mt-1 text-sm text-midnight/60" data-testid="footer-phone">{settings.phone}</p>
          )}
          {settings?.address && (
            <div className="mt-5" data-testid="footer-address">
              <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-gold mb-1.5">Dubai Office</p>
              <p className="text-xs text-midnight/55 leading-relaxed whitespace-pre-line">{settings.address}</p>
            </div>
          )}
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.15em] text-gold mb-4">Products</p>
          <ul className="space-y-2.5 text-sm text-midnight/60">
            <li><a href="/#capabilities" onClick={(e) => { e.preventDefault(); scrollToHash("#capabilities"); }} className="hover:text-midnight transition-colors">Product Categories</a></li>
            <li><a href="/#gpu" onClick={(e) => { e.preventDefault(); scrollToHash("#gpu"); }} className="hover:text-midnight transition-colors">Enterprise GPU</a></li>
            <li><a href="/#availability" onClick={(e) => { e.preventDefault(); scrollToHash("#availability"); }} className="hover:text-midnight transition-colors">Availability</a></li>
            <li><a href="/#builder" onClick={(e) => { e.preventDefault(); scrollToHash("#builder"); }} className="hover:text-midnight transition-colors">Royal AI Builder</a></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.15em] text-gold mb-4">Company</p>
          <ul className="space-y-2.5 text-sm text-midnight/60">
            <li><Link to="/company" className="hover:text-midnight transition-colors">About Royal Deals FZ-LLC</Link></li>
            <li><Link to="/supply" className="hover:text-midnight transition-colors">Supply &amp; Sourcing</Link></li>
            <li><Link to="/register" data-testid="footer-register-link" className="hover:text-midnight transition-colors">Register Your Company</Link></li>
            <li><Link to="/request" className="hover:text-midnight transition-colors">Submit Requirement</Link></li>
            <li><Link to="/contact" className="hover:text-midnight transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.15em] text-gold mb-4">Legal</p>
          <ul className="space-y-2.5 text-sm text-midnight/60">
            <li><Link to="/privacy" className="hover:text-midnight transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-midnight transition-colors">Terms of Use</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-midnight/10 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-2">
          <p className="text-xs font-medium tracking-wide text-midnight/50" data-testid="footer-legal-name">
            © {new Date().getFullYear()} Royal Deals FZ-LLC · Trade Licence No. 5040984
          </p>
          <p className="text-xs tracking-wide text-midnight/50 max-w-xl md:text-right" data-testid="footer-registered-address">
            Registered in Ras Al Khaimah, United Arab Emirates · VUEP1860, Compass Building – Al Hulaila, Al Hulaila Industrial Zone-FZ, Ras Al Khaimah, United Arab Emirates
          </p>
        </div>
      </div>
    </footer>
  );
};
